// extracted by mini-css-extract-plugin
export default {"buttonLink":"styles_buttonLink__cCes2","lineButtonLink":"styles_lineButtonLink__ihFSR"};